/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateInsightInput = {
    name?: string | null | undefined;
    category?: string | null | undefined;
    components?: Array<InsightComponentInputType | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type InsightComponentInputType = {
    id?: string | null | undefined;
    componentName?: string | null | undefined;
    x?: number | null | undefined;
    y?: number | null | undefined;
    w?: number | null | undefined;
    h?: number | null | undefined;
    config?: string | null | undefined;
};
export type createInsightMutationVariables = {
    input: CreateInsightInput;
};
export type createInsightMutationResponse = {
    readonly createInsight: {
        readonly insight: {
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly category: string | null;
                readonly components: ReadonlyArray<{
                    readonly id: string;
                    readonly componentName: string | null;
                    readonly config: string | null;
                    readonly w: number | null;
                    readonly h: number | null;
                    readonly x: number | null;
                    readonly y: number | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type createInsightMutation = {
    readonly response: createInsightMutationResponse;
    readonly variables: createInsightMutationVariables;
};



/*
mutation createInsightMutation(
  $input: CreateInsightInput!
) {
  createInsight(input: $input) {
    insight {
      node {
        id
        name
        category
        components {
          id
          componentName
          config
          w
          h
          x
          y
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateInsightInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateInsightPayload",
    "kind": "LinkedField",
    "name": "createInsight",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InsightTypeEdge",
        "kind": "LinkedField",
        "name": "insight",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Insight",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InsightComponent",
                "kind": "LinkedField",
                "name": "components",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "componentName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "config",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "w",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "h",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "x",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "y",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createInsightMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createInsightMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createInsightMutation",
    "operationKind": "mutation",
    "text": "mutation createInsightMutation(\n  $input: CreateInsightInput!\n) {\n  createInsight(input: $input) {\n    insight {\n      node {\n        id\n        name\n        category\n        components {\n          id\n          componentName\n          config\n          w\n          h\n          x\n          y\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '356ce469eba59566dfffdcf87ad0fc41';
export default node;
